import { updateUserContext } from "@utils/api/tracker";
import { ActionHandlerParams } from "..";
import { isEligibleForTelehealthReimbursement } from "src/utils/userSegment/features";
import { clearCheckoutTimerExpirationCookie } from "src/utils/checkoutTimer";
import saveToBraze from "@utils/brazeUploader";
import { getRouteId } from "@utils/meristemContext";
import { saveAnswers } from "./saveAnswers";

type Params = {
  finishedEvent?: string;
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompletePaymentSurvey = async (
  actionParams: {
    params?: Params;
  } & ActionHandlerParams
) => {
  const { params = {} } = actionParams;

  // Clear the checkout timer when we attempt to save answers to the database
  await clearCheckoutTimerExpirationCookie();

  const currentAnswers = await saveAnswers({
    ...actionParams,
    params: {
      ...params,
      dateKey: params.dateKey || "purchaseSurveyCompleteDateISO",
    },
  });

  updateUserContext({
    telehealthEligible: isEligibleForTelehealthReimbursement(),
  });

  await saveToBraze({
    event: {
      event_name: "finished_payment_survey",
      event_data: { routeId: getRouteId(), ...currentAnswers },
    },
  });
};
